// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-container {
    margin: 15px 0;
}

.dropdown-label {
    font-size: 14px;
    font-weight: 500;
    color: var(--therapist-text-color);
    margin-bottom: 8px;
}

.dropdown-select {
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 14px;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.dropdown-select:focus {
    border-color: var(--therapist-accent-color);
    box-shadow: 0 0 0 0.2rem rgba(52, 117, 172, 0.25);
}
`, "",{"version":3,"sources":["webpack://./app/components/therapist/medical-history/styles/DropdownField.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,2CAA2C;IAC3C,iDAAiD;AACrD","sourcesContent":[".dropdown-container {\n    margin: 15px 0;\n}\n\n.dropdown-label {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--therapist-text-color);\n    margin-bottom: 8px;\n}\n\n.dropdown-select {\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.dropdown-select:focus {\n    border-color: var(--therapist-accent-color);\n    box-shadow: 0 0 0 0.2rem rgba(52, 117, 172, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
